import type { FC } from 'react';
import React from 'react';

import { Size } from '../types';
import {
  Content,
  EditIconWrapper,
  StyledEditIcon,
  TextWrapper,
  WorkspaceAvatarImage,
  Wrapper,
} from './WorkspaceAvatar.styled';

export type WorkSpaceAvatarProps = {
  /**
   * Indicates whether to show an edit icon on hover
   */
  editable?: boolean;
  /**
   * Defines the name of the workspace whose first two letters will be used
   */
  name?: string;
  /**
   * Function for WorkspaceAvatar click
   */
  onClick?: () => void;
  /**
   * Changes the size. It can be one of the following options: `WorkspaceAvatar.Size.XS`, `WorkspaceAvatar.Size.S`,
   *  `WorkspaceAvatar.Size.M`, `WorkspaceAvatar.Size.L`, `WorkspaceAvatar.Size.XL`, `WorkspaceAvatar.Size.XXL`, `WorkspaceAvatar.Size.XXXL`
   */
  size?: Size;
  /**
   * The URL of the image of the user avatar
   */
  src?: string;
  /**
   * Property used for testing purposes
   */
  dataCy?: string;
};

const WorkspaceAvatar: FC<WorkSpaceAvatarProps> & { Size: typeof Size } = ({
  editable = false,
  name,
  onClick,
  size = Size.M,
  src,
  dataCy,
}) => {
  return (
    <Wrapper $size={size} $editable={editable} onClick={onClick}>
      <Content>
        {name && !src && (
          <TextWrapper $size={size} data-cy={dataCy}>
            {name.substring(0, 2)}
          </TextWrapper>
        )}
        {(!name || src) && (
          <WorkspaceAvatarImage $src={src} $size={size} data-cy={dataCy} />
        )}
        {editable && (
          <EditIconWrapper>
            <StyledEditIcon />
          </EditIconWrapper>
        )}
      </Content>
    </Wrapper>
  );
};

WorkspaceAvatar.Size = Size;

export default WorkspaceAvatar;
